import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ClienteAutocomplete from "./AutocompleteCliente";

const AgregarClienteEspecialModal = ({ open, onClose, tipo }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [cliente, setCliente] = useState({
        idCliente: 0,
        razonSocial: "",
        comentario: "",
        especial: true,
        tipo: ""
    });

    const [evidencia, setEvidencia] = useState({
        documento: "",
        extension: "",
    })

    const AgregarCliente = () => {
        if (cliente.idCliente === "" || cliente.idCliente === null || cliente.idCliente === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe seleccionar un cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (cliente.comentario === "" || cliente.comentario === null || cliente.comentario === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe escribir un comentario",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (cliente.especial === "" || cliente.especial === null || cliente.especial === undefined) {
            Swal.fire({
                title: "CLIENTES ESPECIALES",
                text: "Debe seleccionar un estado para el cliente",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        const post = {
            idcliente: cliente.idCliente,
            comentarios: cliente.comentario,
            estatus: cliente.especial,
            tipo_cliente: tipo,
            usuario: 0,
            // documento: evidencia.documento,
            // extension: evidencia.extension
        };

        setLoader({ ...loader, mostrar: true });
        request
            .post("ClientesEspeciales", post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "CLIENTES ESPECIALES",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CLIENTES ESPECIALES", JSON.stringify(error), "error");
            });
    };

    const handleSelectCliente = (id, razonSocial) => {
        setCliente({
            ...cliente,
            idCliente: id,
            razonSocial: razonSocial,
        });
    };

    const GetFile = ({ target }) => {
        const file = target.files[0].name.split(".");
        if (file.length > 2) {
            Swal.fire("Clientes", "Archivo invalido", "error");
            return;
        }

        if (
            file[1] !== "jpg" &&
            file[1] !== "jepg" &&
            file[1] !== "pdf" &&
            file[1] !== "PDF"
        ) {
            Swal.fire("Clientes", "Archivo con formato no valido", "error");
            target.value = "";
            return;
        }
        var fReader = new FileReader();
        fReader.readAsDataURL(target.files[0]);
        fReader.onloadend = function (event) {
            setEvidencia({
                ...evidencia,
                documento: event.target.result,
                extension: file[1],
            });
        };
    };

    // console.log(cliente)
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="agregar-cliente-especial-modal-formulario">
                    <div className="agregar-cliente-especial-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"AGREGAR CLIENTE ESPECIAL"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`agregar-cliente-especial-modal-agregar-convenio`}>
                                    <div className="agregar-cliente-especial-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Registrar Nuevo Cliente Especial</h3>
                                        {/* <div className="agregar-objecion-modal-estatus">
                                            <input
                                                type="checkbox"
                                                name="convenio"
                                                className="chk-groups"
                                                id="convenio"
                                                checked={objecion.estatus}
                                                onChange={(e) => {
                                                    setObjecion({
                                                        ...objecion,
                                                        estatus: e.target.checked,
                                                    });
                                                }}
                                            />
                                            <span>Estatus</span>
                                        </div> */}
                                        <ClienteAutocomplete onSelectCliente={handleSelectCliente} tipo={tipo} />
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Comentario"
                                            sx={{ mt: 2 }}
                                            value={cliente.comentario}
                                            onChange={(e) => {
                                                setCliente({
                                                    ...cliente,
                                                    comentario: e.target.value,
                                                });
                                            }}
                                        />
                                        <TextField
                                            className="input-medio-comunicacion"
                                            fullWidth
                                            size="small"
                                            label="Estado"
                                            select
                                            type="text"
                                            value={cliente.especial}
                                            onChange={(e) => {
                                                setCliente({
                                                    ...cliente,
                                                    especial: e.target.value,
                                                });
                                            }}
                                            sx={{ mt: 2 }}
                                        >
                                            <MenuItem value={true}>Vigente</MenuItem>
                                            <MenuItem value={false}>Cancelado</MenuItem>
                                        </TextField>
                                        {/* <TextField
                                            className="input-medio-comunicacion"
                                            fullWidth
                                            size="small"
                                            label="Tipo"
                                            select
                                            type="text"
                                            value={cliente.tipo}
                                            onChange={(e) => {
                                                setCliente({
                                                    ...cliente,
                                                    tipo: e.target.value,
                                                });
                                            }}
                                            sx={{ mt: 2 }}
                                        >
                                            <MenuItem value={'P'}>Plataforma</MenuItem>
                                            <MenuItem value={'N'}>No Paga Intereses</MenuItem>
                                            <MenuItem value={'F'}>No Firma Pagare</MenuItem>
                                        </TextField>
                                        <TextField
                                            id="clientes-documento"
                                            type="file"
                                            onChange={GetFile}
                                            sx={{ mb: 2, mt: 2 }}
                                        /> */}
                                    </div>
                                    <div className="agregar-cliente-especial-modal-buttons">
                                        <button
                                            className="agregar-cliente-especial-modal-button-guardar"
                                            onClick={() => AgregarCliente()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default AgregarClienteEspecialModal;